import {
  PATIENT_ADVOCATES_REQUEST,
  PATIENT_ADVOCATES_SUCCESS,
  PATIENT_ADVOCATES_FAILURE,
  EMPLOYERS_TYPEAHEAD_REQUEST,
  EMPLOYERS_TYPEAHEAD_SUCCESS,
  EMPLOYERS_TYPEAHEAD_FAILURE,
  ADD_ACTION_REQUEST,
  ADD_ACTION_SUCCESS,
  ADD_ACTION_FAILURE,
  SET_VIEW,
  ADVOCATE_REQUEST,
  ADVOCATE_SUCCESS,
  ADVOCATE_FAILURE,
  AUDIT_LOG_REQUEST,
  AUDIT_LOG_SUCCESS,
  AUDIT_LOG_FAILURE,
  LOCATIONS_TYPEAHEAD_REQUEST,
  LOCATIONS_TYPEAHEAD_SUCCESS,
  LOCATIONS_TYPEAHEAD_FAILURE,
  ADVOCATE_QUERY_REQUEST,
  ADVOCATE_QUERY_SUCCESS,
  ADVOCATE_QUERY_FAILURE,
} from './AdvocateActions';

const initialState = {
  data: [],
  typeahead: [],
  locations: [],
  queries: [],
  advocate: {},
  error: null,
  isLoading: false,
  isAdvocateLoading: false,
  view: null,
  audit: null,
  isAuditLogLoading: false
};

export default function advocateReducer(
  state = initialState,
  { type, payload, view, meta },
) {
  switch (type) {
    case PATIENT_ADVOCATES_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_ADVOCATES_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case PATIENT_ADVOCATES_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case EMPLOYERS_TYPEAHEAD_REQUEST:
      return { ...state, isLoading: true };
    case EMPLOYERS_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        typeahead: payload.data,
        errors: null,
        isLoading: false,
      };
    case EMPLOYERS_TYPEAHEAD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case LOCATIONS_TYPEAHEAD_REQUEST:
      return { ...state, isLoading: true };
    case LOCATIONS_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        locations: payload.data,
        errors: null,
        isLoading: false,
      };
    case LOCATIONS_TYPEAHEAD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case ADD_ACTION_REQUEST:
      return { ...state, isActionSubmitting: true };
    case ADD_ACTION_SUCCESS:
      return { ...state, error: null, isActionSubmitting: false };
    case ADD_ACTION_FAILURE:
      return { ...state, error: payload.error, isActionSubmitting: false };

    case SET_VIEW:
      return { ...state, view };

    case ADVOCATE_REQUEST:
      return { ...state, isAdvocateLoading: true };
    case ADVOCATE_SUCCESS:
      return {
        ...state,
        advocate: { ...state.advocate, [meta.patientID]: payload.data },
        error: false,
        isAdvocateLoading: false
      };
    case ADVOCATE_FAILURE:
      return { ...state, error: payload.error, isAdvocateLoading: false };

    case AUDIT_LOG_REQUEST:
      return { ...state, isAuditLogLoading: true, };
    case AUDIT_LOG_SUCCESS:
      return {
        ...state,
        audit: payload.data,
        error: false,
        isAuditLogLoading: false
      };
    case AUDIT_LOG_FAILURE:
      return { ...state, error: payload.error, isAuditLogLoading: false };

    case ADVOCATE_QUERY_REQUEST:
      return { ...state, isAdvocateLoading: true };
    case ADVOCATE_QUERY_SUCCESS:
      return {
        ...state,
        queries: payload.data,
        error: false,
        isAdvocateLoading: false
      };
    case ADVOCATE_QUERY_FAILURE:
      return { ...state, error: payload.error, isAdvocateLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/advocate-dashboard/AdvocateReducer.js